export enum Sentiments {
    question = 1,
    praise = 2,
    suggestion = 3,
    complaint = 4,
}
